// extracted by mini-css-extract-plugin
export var statItem = "_lh-1";
export var statsRow = "_lh-0";